import React from "react";
import { individualSite } from "utils/determineSite";
import { Card } from "react-bootstrap";
import IconHeader from "./IconHeader";
import IconSubheader from "./IconSubheader";

const AccountProcedureDisclosure = () => {
  const isIndividual = individualSite();
  return (
    <div>
      <Card
        style={{
          border: "none",
          boxShadow: "none",
          padding: 30,
          margin: 0,
          borderRadius: 5,
        }}
      >
        <Card.Header
          style={{
            padding: 0,
          }}
        >
          <IconHeader
            variant="infoCardHeader"
            style={{ color: "#5E6B75" }}
            headerText="Important Information About Procedures for Opening a New Account"
          />
        </Card.Header>
        <Card.Body>
          <IconSubheader
            style={{ fontSize: 14, marginBottom: 0, color: "#5E6B75" }}
          >
            {isIndividual ? (
              <div>
                <p style={{ fontSize: 14 }}>
                  To help the government fight the funding of terrorism and
                  money laundering activities, federal law requires all U.S.
                  financial institutions to obtain, verify, and record
                  information that identifies each person that opens an account
                  or establishes a customer relationship with Icon.
                </p>
                <p style={{ fontSize: 14 }}>
                  <strong>What this means for you:</strong> When you open an
                  account or enter into a new customer relationship with Icon,
                  we will ask for name, address, date of birth, social security
                  number, and other information that will allow us to identify
                  you. We may also ask to see your identifying documents.
                </p>
              </div>
            ) : (
              <div>
                <p style={{ fontSize: 14 }}>
                  To help the government fight the funding of terrorism and
                  money laundering activities, federal law requires all U.S.
                  financial institutions to obtain, verify, and record
                  information that identifies each legal entity that opens an
                  account or establishes a customer relationship with Icon.
                </p>
                <p style={{ fontSize: 14 }}>
                  <strong>What this means for you:</strong> When you or the
                  business or organization you represent opens an account or
                  enters into a new customer relationship with Icon, we will ask
                  for the name, address, tax id, and other information that will
                  allow us to identify you and all entities you represent. We
                  may also ask to see your or your entity’s identifying
                  documents.
                </p>
              </div>
            )}
          </IconSubheader>
        </Card.Body>
      </Card>
    </div>
  );
};
export default AccountProcedureDisclosure;
